import React from 'react'

export const NavigateContext = React.createContext({
    newTab: (url, tabName) => { },
    closeTab: (id, redirectUrl) => { },
    setTabPinnable: (pinnable) => { },
    openLeavingModal: (onConfirm) => { },
    closeLeavingModal: () => { },
})

